<template>
    <layout title="Contract Fulfillment Summary">
        <div class="px-8 lg:grid lg:grid-cols-12 lg:gap-x-10">
            <section class="lg:col-span-8">
                <contract-summary :contracts="contracts"></contract-summary>
            </section>
            <section class="lg:col-span-4">
                <non-contract-summary :non-contracts="nonContracts"></non-contract-summary>
            </section>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import ContractSummary from "@/Components/CottonseedPayments/ContractSummary";
import NonContractSummary from "@/Components/CottonseedPayments/NonContractSummary";

export default {
    components: {NonContractSummary, ContractSummary, Layout},
    props: {
        contracts: {
            type: Array,
            default: []
        },
        nonContracts: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
        }
    },
}
</script>
